import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { DeviationVehicle } from '@/types/deviation-vehicle'

export function deleteDeviationVehicle(
  deviationVehicleUuid: string
): Promise<AxiosResponse<DeviationVehicle>> {
  return instance.delete(`/deviation-vehicle/${deviationVehicleUuid}`)
}
